<form [formGroup]="form">
  <div class="flex items-center gap-4">
    <pr-practice-selector
      class="flex-1"
      [brands]="brands$ | async"
      [practice]="selectedPractice$ | async"
      (practiceSelected)="selectedPractice$.next($event)"
    />

    <mat-form-field class="flex-1">
      <mat-select formControlName="locationUid">
        <ng-container *ngIf="options$ | async as options">
          <mat-option
            *ngFor="
              let location of options.options;
              trackBy: options.trackByOption
            "
            [value]="location.value"
          >
            {{ location.label }}
          </mat-option>
        </ng-container>
      </mat-select>

      <mat-label>
        <pt-loader-placeholder
          placeholder="Select Podium Location"
          loadingPlaceholder="Loading Locations..."
          [loading]="loading$ | async"
        />
      </mat-label>
    </mat-form-field>

    <div matTextSuffix (click)="$event.stopImmediatePropagation()">
      <ng-content />
    </div>
  </div>
</form>
